<template>
  <div id="left">
    <div class="leftnav box">
      <h3 class="title"><strong>新闻分类</strong></h3>
      <ul>
        <li>><a href='/#/shiShiXinWen' title='时事新闻'>时事新闻</a></li>
        <li>><a href='/#/hangYeZiXun' title='行业资讯'>行业资讯</a></li>
        <li>><a href='/#/gaoXinJiShu' title='高新技术'>高新技术</a></li>
        <li>><a href='/#/guoNeiZiXun' title='国内资讯'>国内资讯</a></li>
        <li>><a href='/#/quanQiuZiXun' title='全球资讯'>全球资讯</a></li>
        <li>><a href='/#/huLianWangJiaNews' title='互联网+新闻'>互联网+新闻</a></li>
        <li>><a href='/#/hangYeHuoDong' title='行业活动'>行业活动</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftSide"
}
</script>

<style scoped>

</style>